module.exports = __webpack_public_path__ + "img/nurse_cert_bg.f140df8c.png";